export const homePath = () => {
  return process.env.PUBLIC_URL.includes("nomnom") ? "/nomnom-web" : "/";
};
export const basePath = (suffix) => {
  if (suffix) {
    return process.env.PUBLIC_URL.includes("nomnom") ? `/nomnom-web/${suffix}` : `/${suffix}`;
  }
  return process.env.PUBLIC_URL.includes("nomnom") ? "/nomnom-web" : "";
};